import { render, staticRenderFns } from "./sapcontacts.vue?vue&type=template&id=144fdc4a"
import script from "./sapcontacts.vue?vue&type=script&lang=js"
export * from "./sapcontacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports